(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-delivery-estimate"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cart-delivery-estimate')) {
    customElements.define(
      'cart-delivery-estimate',
      class CartDeliveryEstimate extends HTMLElement {
        connectedCallback() {
          const timezone = 'Europe/Dublin';

          const parts = new Intl.DateTimeFormat('en-IE', {
            timeZone: timezone,
            year: 'numeric',
            month: 'numeric',
            day: 'numeric'
          }).formatToParts(new Date());

          const values = {};

          parts.forEach((part) => {
            if (part.type !== 'literal') {
              values[part.type] = Number(part.value);
            }
          });

          const today = new Date(
            Date.UTC(values.year, values.month - 1, values.day)
          );

          const addBusinessDays = (date, amount) => {
            const result = new Date(date);
            let count = 0;

            while (count < amount) {
              result.setUTCDate(result.getUTCDate() + 1);

              const weekday = result.getUTCDay();

              if (weekday >= 1 && weekday <= 5) {
                count += 1;
              }
            }

            return result;
          };

          const deliveryStart = addBusinessDays(today, 2);
          const deliveryEnd = addBusinessDays(today, 3);

          const formatDate = (date) =>
            new Intl.DateTimeFormat('en-IE', {
              weekday: 'short',
              day: 'numeric',
              month: 'short',
              timeZone: 'UTC'
            }).format(date);

          const range = this.querySelector('[data-delivery-range]');

          if (range) {
            range.textContent =
              `${formatDate(deliveryStart)} – ${formatDate(deliveryEnd)}`;
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
